import { IconMail, IconUser, IconCalendarEvent, IconFlag, IconFilter, IconBriefcase2, IconSitemap } from "@tabler/icons-react";
import imgs from "../../../../Utils/assets/img/faces/5.jpg";
import { formatDate } from "../../../../Utils/helpers/commonhelper";
import Tooltip from "@mui/material/Tooltip";
import useLocalStorageState from "use-local-storage-state";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetRequest } from "../../../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import nodata from "../../../../Utils/assets/img/leads_no_data_found.png"
import { Col, Dropdown, Row } from "react-bootstrap";
import { FilterPagination } from "../../../../pages/FIlterPagination";
import { AuthorizationCard } from "../../../../pages/AuthorizationCard";
import { useOutsideClickHandler } from "../../../../Utils/hooks/useOutsideClickHandler";
import { ContactTaskDetallsCard } from "./ContactTaskDetallsCard";
import "../MyTaskBoard.css"

export const MyTask = ({ searchInput }) => {
  const [customer, setCustomer] = useLocalStorageState('customer');
  const navigate = useNavigate();
  const brandColor = "#7a3a5e";

  const [myTask, setMyTask] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currTaskId, setCurrTaskId] = useState(null)
  const [currContactId, setCurrContactId] = useState(null)
  const [currOwnerId, setCurrOwnerId] = useState(null)

  // for opening dropdown
  const [openFilter, setOpenFilter] = useState(false)
  const filterDropRef = useRef(null)
  const [filter, setFilter] = useState(`Due Task`)
  const [showCustomInputs, setShowCustomInputs] = useState(false);
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  // pagination states
  const [offset, setOffset] = useState(0)
  const limit = 20
  const [totalTask, setTotalTask] = useState(0)
  // Calculate total pages
  const pageCount = Math.ceil(Number(totalTask) / limit);
  const startItem = totalTask === 0 ? 0 : offset + 1;
  const endItem = Math.min(offset + limit, totalTask);

  // permission setup for conntacts
  const permission = customer.customer_details?.permission
  const contactPermssion = permission?.filter(c => c.module_name === "contact")
  const user_type = Number(customer.customer_details?.user_type)
  const taskGrant = {
    isView: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "followup")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "followup")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "followup")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "followup")?.delete)) : true,
  }

  // custom hook for outside click
  useOutsideClickHandler({
    objRef: filterDropRef,
    isDropdown: openFilter,
    setDropdown: setOpenFilter
  })

  const fetchMyTask = async () => {
    setLoading(true);
    try {
      const customer_id = customer?.customer_details?.customer_id;
      const headers = {
        Authorization: customer?.token?.authorization || "",
        Authentication: customer?.token?.authentication || "",
      };
      const extras = { customer, setCustomer, rf: customer?.token?.authentication, navigate };

      let filterValue = filter.trim().toLowerCase().split(" ").join("_");
      filterValue = filterValue === "all_task" ? "all" :
        filterValue === "today_task" ? "today" :
          filterValue === "due_task" ? "due" : "custom";

      const res = await GetRequest(`taskboard/myTasks/${customer_id}/${customer?.customer_details?.id}/${filterValue}?from=${customFrom}&to=${customTo}&limit=${limit}&offset=${offset}&search=${searchInput}`, { headers }, extras);

      if (res.status === false) {
        toast.error(res.message);
        return
      }
      setTotalTask(res?.total_count)
      setMyTask(res.data || []);

    } catch (error) {
      return
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMyTask();
  }, [filter, customFrom, customTo, offset]);

  // just to ensure when user will make any search then whichever current page it is on that should be reset to 0
  useEffect(() => {
    if (searchInput?.trim()?.length !== 0) {
      setOffset(0)
    }
    fetchMyTask()
  }, [searchInput])


  useEffect(() => {
    if (!myTask) return
    setCurrContactId(myTask[0]?.contact_id)
    setCurrOwnerId(myTask[0]?.owner_id)
    setCurrTaskId(myTask[0]?.id)
  }, [myTask])

  // Priority styling helper
  const getPriorityStyle = (priority) => {
    const p = priority?.toLowerCase();
    if (p === "high") {
      return { bg: "#fee2e2", color: "#dc2626" };
    }
    if (p === "medium") {
      return { bg: "#fef9c3", color: "#ca8a04" };
    }
    return { bg: "#dbeafe", color: "#2563eb" };
  };

  if (!taskGrant?.isView) {
    return <AuthorizationCard />
  }

  return (
    <Row
      className="Projectscard w-100 mx-0 mb-2 g-0"
    >
      <Col md={5} className="listStyleForContact bg-white px-3 pb-3 pt-0 meetings-scroll-container  d-flex flex-column gap-2 ms-0" style={{ minHeight: "calc(100vh - 14rem)", maxHeight: "calc(100vh - 14rem)", overflowY: "auto", overflowX: "hidden", position: 'relative', borderRight: "1px solid rgb(224, 228, 248)" }}>
        <div
          className="d-flex align-items-center justify-content-between position-sticky py-2 px-1"
          style={{
            top: "0rem",
            zIndex: 100,
            background: "white",
          }}
        >
          <p className="mb-0" style={{ fontSize: "14px" }}>
            Showing {startItem}-{endItem} of {totalTask} items
          </p>
          <Dropdown
            style={{ zIndex: 99, }}
            show={openFilter}
            ref={filterDropRef}
          >
            <Dropdown.Toggle
              as="button"
              onClick={() => setOpenFilter(prev => !prev)}
              className="btn btn-light  d-flex align-items-center border gap-2 px-3 py-2 text-muted no-arrow"
              style={{ fontSize: '13px', borderRadius: '8px', fontWeight: '600' }}
            >
              <IconFilter size={16} color="#7a3a5e" />
              {filter}
              <i className="fa-solid fa-chevron-down align-middle ms-1 d-inline-block"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="shadow" style={{ zIndex: 9999, marginTop: "3px" }} align={"end"}>
              <Dropdown.Item
                onClick={() => {
                  setFilter(`All Task`);
                  setOffset(0)
                  setShowCustomInputs(false);
                  setOpenFilter(false);
                }}
              >
                All Tasks
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setFilter(`Today Task`);
                  setShowCustomInputs(false);
                  setOffset(0)
                  setOpenFilter(false);
                }}
              >
                Today Task
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setFilter(`Due Task`);
                  setShowCustomInputs(false);
                  setOffset(0)
                  setOpenFilter(false);
                }}
              >
                Due Task
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setShowCustomInputs(true);
                  setOffset(0)
                }}
              >
                Custom Task
                {showCustomInputs && (
                  <div className="d-flex gap-2 mt-2">
                    <input
                      type="date"
                      className="form-control"
                      value={customFrom}
                      onChange={(e) => setCustomFrom(e.target.value)}
                      placeholder="From"
                    />

                    <input
                      type="date"
                      className="form-control"
                      value={customTo}
                      onChange={(e) => setCustomTo(e.target.value)}
                      placeholder="To"
                    />
                    <button className="btn-sm btn-default" onClick={() => {
                      setFilter(`Custom Task`);
                    }}>
                      Submit
                    </button>
                  </div>
                )}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {
          myTask?.length > 0 ? (
            myTask.map((item, index) => {
              const cardColors = ["#2b0dff05", "#ff330005"]
              const cardColor = cardColors[index % cardColors.length]
              const pStyle = getPriorityStyle(item?.priority)
              return <>
                <div
                  key={item.id}
                  className={`meeting-card position-relative ${currTaskId === item?.id ? "shadow-sm" : ""}`}
                  style={{
                    backgroundColor: cardColor,
                    cursor: "pointer",
                    border:
                      currTaskId === item?.id
                        ? cardColor === "#2b0dff05"
                          ? "2px solid #c5beff80"
                          : "2px solid #ffc0b380"
                        : "1px solid #efefef",
                    transition: "border 0.2s ease-in-out",
                  }}
                  onClick={(e) => {
                    e.preventDefault()
                    setCurrContactId(item?.contact_id)
                    setCurrOwnerId(item?.owner_id)
                    setCurrTaskId(item?.id)
                  }}
                >
                  <div className="meeting-info">
                    <h4
                      className="meeting-title"
                      style={{ textTransform: "capitalize", fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
                    >
                      <span
                        className="contact-name fw-semibold cursor-pointer transition-all"
                        style={{ fontSize: '14px', textTransform: "capitalize", whiteSpace: "nowrap" }}
                      >
                        {`${item?.first_name} ${item?.last_name}`}
                      </span>
                    </h4>
                  </div>

                  <div className="d-flex gap-3 align-items-center w-100">
                    <div className="d-flex align-items-start flex-fill" style={{ minWidth: 0 }}>
                      <div
                        className="d-flex align-items-center justify-content-center rounded-full"
                        style={{
                          backgroundColor: "#f1f5f9",
                          borderRadius: "50%",
                          minWidth: "32px",
                          height: "32px",
                          color: "#2656a8",
                          marginRight: '8px',
                          marginTop: "4px",
                          border: "1px solid #d5e4ff",
                        }}
                      >
                        <IconCalendarEvent size={14} className="" stroke={1.5} />
                      </div>
                      <div
                        className="d-flex flex-column align-items-start flex-fill"
                        style={{
                          // borderRight: '1px solid #e5e7eb',
                          paddingRight: '1rem',
                          minWidth: 0,
                        }}
                      >
                        <span className="d-flex align-items-center  text-muted" style={{ fontSize: "12px" }}>Due Date</span>
                        <span className="text-truncate" style={{ fontSize: '14px', color: "red", fontWeight: 400 }}> {formatDate(item?.due_date)}</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-start flex-fill" style={{ minWidth: 0 }}>
                      <div
                        className="d-flex align-items-center justify-content-center rounded-full"
                        style={{
                          backgroundColor: "#f1f5f9",
                          borderRadius: "50%",
                          minWidth: "32px",
                          height: "32px",
                          color: "#2656a8",
                          marginRight: '8px',
                          marginTop: "4px",
                          border: "1px solid #d5e4ff",
                        }}
                      >
                        <IconBriefcase2 size={14} className="" stroke={1.5} />
                      </div>
                      <div
                        className="d-flex flex-column align-items-start flex-fill"
                        style={{
                          // borderRight: '1px solid #e5e7eb',
                          paddingRight: '1rem',
                          minWidth: 0,
                        }}
                      >
                        <span className="d-flex align-items-center  text-muted" style={{ fontSize: "12px" }}>Task Name</span>
                        <span
                          className="text-truncate"
                          style={{
                            fontSize: '14px',
                            textTransform: 'capitalize',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '120px',
                            display: 'block',
                            fontWeight: 400
                          }}
                        >
                          {item?.name || '-'}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-start flex-fill" style={{ minWidth: 0 }}>
                      <div
                        className="d-flex align-items-center justify-content-center fullounded-2"
                        style={{
                          backgroundColor: "#f1f5f9",
                          borderRadius: "50%",
                          minWidth: "32px",
                          height: "32px",
                          color: "#2656a8",
                          marginRight: '8px',
                          marginTop: "4px",
                          border: "1px solid #d5e4ff",
                        }}
                      >
                        <IconSitemap size={14} className="" stroke={1.5} />
                      </div>
                      <div className="d-flex flex-column align-items-start ">
                        <span className="d-flex align-items-center  text-muted" style={{ fontSize: "12px" }}>Priority</span>
                        <span
                          className="text-truncate"
                          style={{
                            fontSize: '14px',
                            textTransform: 'capitalize',
                            color: pStyle.color,
                            fontWeight: 400,
                          }}
                        >
                          {item?.priority || '-'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            })
          )
            :
            <div
              class="d-flex justify-content-center align-items-center"
              style={{ position: "absolute", left: "25%", top: "30%" }}
            >
              <img
                src={nodata}
                alt=""
                style={{ width: "17rem", marginTop: "0" }}
              />
            </div>
        }
        {
          myTask?.length !== 0 &&
          <div
            className=" d-flex justify-content-end align-items-center mt-2"
          >
            <FilterPagination
              offset={Math.floor(offset / limit)}
              setOffset={setOffset}
              handlePageChange={(selectedItem) => {
                setOffset(selectedItem.selected * limit)
              }}
              pageCount={pageCount}
              limit={limit}
            />
          </div>
        }
      </Col >

      <Col md={7} className=" px-2" style={{ minHeight: "calc(100vh - 14rem)", maxHeight: "calc(100vh - 14rem)", overflowY: "auto", overflowX: "hidden", position: 'relative' }}>

        {
          currTaskId !== null &&
          <ContactTaskDetallsCard
            contactId={currContactId}
            owner_id={currOwnerId}
            taskId={currTaskId}
            taskEditGrant={taskGrant?.isEdit}
            taskDeleteGrant={taskGrant?.isDelete}
          />
      }
      </Col>
    </Row >
  );
};